import {
  AmpInputEvent,
  OptionList,
} from "@redotech/redo-model/email-builder/amp-utils";
import { CSSProperties } from "react";
import { renderToString } from "react-dom/server";
import { serializedAmpEvent } from "./amp-form-utils";
import { MustacheContext, MustacheSection } from "./amp-variable";

type AmpDynamicSelectProps = {
  id: string;
  name: string;
  onChange?: string;
  scope: MustacheContext<OptionList, ".">;
  style?: CSSProperties;
};

export function AmpDynamicSelect(props: AmpDynamicSelectProps) {
  return (
    <select
      aria-label={props.scope.var("name")}
      dangerouslySetInnerHTML={{
        __html: renderToString(optionsSectionGenerator(props.scope) ?? <div />),
      }}
      id={props.id}
      name={props.name}
      on={serializedAmpEvent<AmpInputEvent>("change", props.onChange)}
      style={props.style}
    />
  );
}

const optionsSectionGenerator = (context: MustacheContext<OptionList, ".">) => (
  <MustacheSection context={context} path={"options" as const} type="foreach">
    {(subContext) => (
      <>
        <MustacheSection
          context={subContext}
          path={"selected" as const}
          type="if"
        >
          <option selected value={subContext.var("value")}>
            {subContext.var("label")}
          </option>
        </MustacheSection>
        <MustacheSection
          context={subContext}
          path={"selected" as const}
          type="unless"
        >
          <option value={subContext.var("value")}>
            {subContext.var("label")}
          </option>
        </MustacheSection>
      </>
    )}
  </MustacheSection>
);
